<template>
  <div class="">
    <Card class="">
      <template #title> Danışanlar </template>
      <template #content>
        <div class="mt-1 mb-2 mr-3">

        </div>
        <DataTable v-if="DataTable_render" :columns="columns" :data="DanisanListesi" v-on:set-child-data="getDataChild"
          :editbutton="true" />
      </template>
    </Card>
  </div>
</template>

<script>
import DataTable from "../../DataTable/BasicDataTable.vue";
import GlobalServis from "../../../../../services/GlobalServis";
import { required, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      DataTable_render: true,
      DanisanListesi: [],
      columns: [
        { field: "MusteriAd", header: "Danışan Adı" },
        { field: "UrunAd", header: "Diyet Paketi" },
        { field: "SatisTarih", header: "Satış Tarih" },
      ],

      DanisanAd: null,
      DanisanAciklama: null,
      Danisan_rowid: null,
    };
  },
  methods: {
    getDataChild(getdata_child) {
      this.Danisan_rowid = getdata_child.data.Musteri_rowid;
      this.$router.push({ path: "/Diyetisyen/DetayDanisan", query: { DanisanNo: this.Danisan_rowid } });
    },
    InitServis() {
      GlobalServis.GlobalServis("GET", "GetDanisanTablosu", "").then((res) => {
        if (res.status == 200) {
          this.DanisanListesi = res.data;
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
      });
    },
  },
  mounted() {
    this.InitServis();
  },
  components: {
    DataTable,
  },
  validations() {
    return {
      DanisanAd: {
        required: helpers.withMessage("Bu alan boş bırakılamaz", required),
      },
      DanisanAciklama: {
        required: helpers.withMessage("Bu alan boş bırakılamaz", required),
      },
    };
  },
};
</script>